import { render } from "./ManageNewsView.vue?vue&type=template&id=a7347d32&scoped=true"
import script from "./ManageNewsView.vue?vue&type=script&lang=js"
export * from "./ManageNewsView.vue?vue&type=script&lang=js"

import "./ManageNewsView.vue?vue&type=style&index=0&id=a7347d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.4.2_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7347d32"]])

export default __exports__